import { API, Auth } from 'aws-amplify'

const POST_NEW_INSTITUTION = async function(data) {
  let apiName = 'ecobanka'
  let path = '/institutions'
  let myInit = {
    body: {
      data: data
    },
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.post(apiName, path, myInit)
}

const POST_SAVE_SEARCH = async function(data) {
  let apiName = 'ecobanka'
  let path = '/institutions/searches'
  let myInit = {
    body: {
      data: data
    },
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.post(apiName, path, myInit)
}

const DELETE_SEARCH = async function(searchId) {
  let apiName = 'ecobanka'
  let path = '/institutions/searches/' + searchId
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.del(apiName, path, myInit)
}

const POST_BAN_KEYWORD = async function(data) {
  let apiName = 'ecobanka'
  let path = '/banned-keywords'
  let myInit = {
    body: {
      data: data
    },
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.post(apiName, path, myInit)
}

const DELETE_UNBAN_KEYWORD = async function(data) {
  let apiName = 'ecobanka'
  let path = '/banned-keywords'
  let myInit = {
    body: {
      data: data
    },
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.del(apiName, path, myInit)
}

const GET_BANNED_KEYWORDS = async function() {
  let apiName = 'ecobanka'
  let path = '/banned-keywords'
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }

  return await API.get(apiName, path, myInit)
}

const GET_SAVED_SEARCHES = async function() {
  let apiName = 'ecobanka'
  let path = '/institutions/searches'
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }

  return await API.get(apiName, path, myInit)
}

const DELETE_INSTITUTION = async function(institutionId) {
  let apiName = 'ecobanka'
  let path = '/institutions/' + institutionId
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.del(apiName, path, myInit)
}

const GET_INSTITUTION_DETAILS = async function(institutionId) {
  let apiName = 'ecobanka'
  let path = '/institutions/' + institutionId
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.get(apiName, path, myInit)
}

const GET_INSTITUTION_PUBLIC_DETAILS = async function(institutionId) {
  let apiName = 'ecobanka'
  let path = '/institutions/' + institutionId + "/public-details"
  let myInit = {

  }
  return await API.get(apiName, path, myInit)
}

export {
  POST_NEW_INSTITUTION,
  POST_SAVE_SEARCH,
  GET_INSTITUTION_DETAILS,
  GET_SAVED_SEARCHES,
  GET_INSTITUTION_PUBLIC_DETAILS,
  DELETE_INSTITUTION,
  DELETE_SEARCH,
  POST_BAN_KEYWORD,
  DELETE_UNBAN_KEYWORD,
  GET_BANNED_KEYWORDS
}
